// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import CourseRequisiteTypeDTO from './CourseRequisiteTypeDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface CourseRequisiteDTO extends EntitySelectorDTO { 
	id: string | null;
	courseId: string | null;
	requisiteCourseId: string | null;
	requisiteCourseTitle: string | null;
	requisiteCourseDisplay: string | null;
	courseRequisiteTypeId: number;
	courseRequisiteType: CourseRequisiteTypeDTO | null;
}

const CourseRequisiteDTO = {
    className: 'CourseRequisiteDTO',
    create: (initValues?: Partial<CourseRequisiteDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: '00000000-0000-0000-0000-000000000000',
			courseId: '00000000-0000-0000-0000-000000000000',
			requisiteCourseId: '00000000-0000-0000-0000-000000000000',
			requisiteCourseTitle: "",
			requisiteCourseDisplay: "",
			courseRequisiteTypeId: 0,
			courseRequisiteType: null,
        },
        initValues);
    },
	id: 'id',
	courseId: 'courseId',
	requisiteCourseId: 'requisiteCourseId',
	requisiteCourseTitle: 'requisiteCourseTitle',
	requisiteCourseDisplay: 'requisiteCourseDisplay',
	courseRequisiteTypeId: 'courseRequisiteTypeId',
	courseRequisiteType: 'courseRequisiteType',
};

export default CourseRequisiteDTO;